import * as z from 'zod/mini'
import { refineWithKey } from '../errors/validation-keys'

/** Field rules for an activity, shared by the forms, the HTTP bodies and the domain operation. */
export const activityFields = {
  name: z.string().check(z.trim(), z.minLength(2), z.maxLength(40)),
  /** A CSS hex colour, `#rgb` or `#rrggbb`, as the colour picker's palette gives it. */
  color: z
    .string()
    .check(
      refineWithKey('validation.colorRequired', (value: string) => /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value)),
    ),
  enableIndividualEvents: z.boolean(),
  enableReservations: z.boolean(),
}
